import { v4 as uuidv4 } from "uuid";
import UserRepository from "../domain/data/UserRepository";
import Role from "../domain/entities/Role";
import User from "../domain/entities/User";
import { roles, users } from "./InitData";

export default class MockUserRepository implements UserRepository {
  private static users: User[] = users;
  private static roles: Role[] = roles;

  async saveUser(user: User, userObject: User): Promise<User> {
    if (!userObject.id) {
      userObject.id = uuidv4();
      userObject.organization = MockUserRepository.users[0].organization;
      MockUserRepository.users.push(userObject);
      return userObject;
    } else {
      const record = MockUserRepository.users.find(
        (record) => record.id === userObject.id
      );
      if (record) {
        record.dateOfBirth = userObject.dateOfBirth;
        record.email = userObject.email;
        record.firstName = userObject.firstName;
        record.lastName = userObject.lastName;
        record.middlename = userObject.middlename;
        //record.organization = userObject.organization;
        record.role = userObject.role;
        record.username = userObject.username;
      }
      return record as User;
    }
  }


  async cognitoCreateUser(
    userid: String,
    email: String
  ): Promise<Boolean> {
    return true;
  }

    async cognitoResendUser(
    userid: String,
    email: String
  ): Promise<Boolean> {
    return true;
  }

    async cognitoCheckUserExist(
    email: String,
  ): Promise<Boolean> {
    return true;
  }

  async getRequestors(user: User): Promise<User[]> {
    throw new Error("Method not implemented.");
  }

  async deleteUser(user: User, userObject: User): Promise<Boolean> {
    const record = MockUserRepository.users.find(
      (record) => record.id === userObject.id
    );
    if (record) {
      MockUserRepository.users = MockUserRepository.users.filter(
        (record) => record.id !== userObject.id
      );
      return true;
    }
    return false;
  }
  async loadSignerDataByShortId(shortid: string): Promise<string> {
    throw new Error("Method not implemented.");
  }
  async getUserByShortId(shortId: string): Promise<User> {
    throw new Error("Method not implemented.");
  }
  async getUserByEmail(organizationId: string, email: string): Promise<User> {
    throw new Error("Method not implemented.");
  }
  async getUsers(user: User): Promise<User[]> {
    return MockUserRepository.users;
  }
  async registerUser(
    firstName: string,
    lastName: string,
    email: string,
    password: string,
    orgName: string
  ): Promise<User | undefined> {
    throw new Error("Method not implemented.");
  }
  async login(username: string, password: string): Promise<User[] | undefined> {
    const filteredResult = MockUserRepository.users.filter(
      (user) => user.username === username
    );
    return filteredResult.map((item) => ({
      ...item,
      role: roles[0],
    }));
  }

  async cognitoAuthLogin(
    username: string,
    password: string
  ): Promise<User[] | undefined> {
    throw new Error("Method not implemented.");
  }

  async cognitoNewPasswordLogin(
    username: string,
    tempPassword: string,
    newPassword: string
  ): Promise<User[] | undefined> {
    throw new Error("Method not implemented.");
  }

  async loginExternal(password: string): Promise<User[] | undefined> {
    return MockUserRepository.users.map((item) => ({
      ...item,
      role: roles[0],
    }));
  }

  async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    return;
  }

  async requestPasswordUpdate(email: string): Promise<boolean> {
    return true;
  }
  async passwordUpdate(
    email: string,
    password: string,
    resetCode: string
  ): Promise<boolean> {
    return true;
  }
  async successPayment(paymentId: string): Promise<boolean> {
    throw new Error("Method not implemented.");
  }

  async cognitoDecode(tokenUrlencoded: URLSearchParams): Promise<User[]> {
    throw new Error("Method not implemented.");
  }

  async cognitoVerify(codeUrlencoded: URLSearchParams): Promise<any> {
    throw new Error("Method not implemented.");
  }

  async mfaRespond(username: string, session: string, code: string): Promise<any> {
    throw new Error("Method not implemented.");
  }

  async mfaSetup(accessToken: string): Promise<{ secretCode: string; email: string }> {
    throw new Error("Method not implemented.");
  }

  async mfaVerifySetup(accessToken: string, code: string): Promise<{ status: string }> {
    throw new Error("Method not implemented.");
  }
}
